<div [@videoAnimation] id="videoWrap" *ngIf="showVideo">
	<div id="video-auth" *ngIf="showVideo" [ngClass]="{'pcVideo':isPC}">
	</div>
	<img src="{{assetsRoute}}/picture/casepracticeteam/bg.png" id="videoShortCut">
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-video/case-practice-authorization-video.component.html